import React, { Component } from 'react';
import { Button, Divider, Table, Modal, Popconfirm } from 'antd';
import { connect } from 'dva';
import ModifyModal from './Components/ModifyModal';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import { getAppCode } from '../../utils/utils';
import { convertData } from '../../utils/convertData';
import styles from './index.less';

const { ListTable } = ListPage;

@connect()
class PublicSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      loading: false,
      modifyModalVisible: false,
      type: '',
      record: {},
      showSettingSteps: false,
      page: 1,
    };
  }

  componentDidMount() {
    this.setColumns();
    this.fetchAllConfigure();
    this.fetchChannelList();
  }

  fetchChannelList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'publicSetting/fetchChannelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        this.setState({ channelList: convertData(res || []), loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchAllConfigure = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'publicSetting/fetchAllConfigure',
      params: {
        appCode: getAppCode(),
      },
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchDeletEscribeNumber = record => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'publicSetting/fetchDeletEscribeNumber',
      params: { id: record.id },
    })
      .then(() => {
        this.setState({
          loading: false,
        });
        this.fetchAllConfigure();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  setColumns = () => {
    const columns = [
      {
        title: '公众号名称',
        dataIndex: 'subscribeName',
        key: 'subscribeName',
      },
      {
        title: 'AppID',
        dataIndex: 'appid',
        key: 'appid',
      },
      {
        title: 'AppSecret',
        dataIndex: 'secret',
        key: 'secret',
      },
      {
        title: '同步栏目',
        dataIndex: 'channelName',
        key: 'channelName',
      },
      {
        title: '是否自动发布',
        dataIndex: 'publish',
        key: 'publish',
        render: text => {
          return <span>{text === 1 ? '是' : '否'}</span>;
        },
      },
      {
        title: '是否自动推送',
        dataIndex: 'push',
        key: 'push',
        render: text => {
          return <span>{text === 1 ? '是' : '否'}</span>;
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => {
          return (
            <span>
              <a onClick={() => this.setState({ modifyModalVisible: true, type: '修改', record })}>
                编辑
              </a>
              <Divider type="vertical" />
              <Popconfirm
                title="确认删除?"
                onConfirm={() => {
                  this.fetchDeletEscribeNumber(record);
                }}
                okText="确定"
                cancelText="取消"
              >
                <a>删除</a>
              </Popconfirm>
            </span>
          );
        },
      },
    ];
    this.setState({ columns });
  };

  closeModifyModal = () => {
    this.setState({ modifyModalVisible: false, record: {} });
  };

  hideSettingSteps = () => {
    this.setState({ showSettingSteps: false });
  };

  changePage = (page, pageSize) => {
    this.setState({ page });
  };

  render() {
    const {
      columns,
      loading,
      dataSource = [],
      modifyModalVisible,
      type,
      record = {},
      showSettingSteps,
      channelList = [],
      page,
    } = this.state;

    const alertParams = {
      states: !0, // true为展示 false不展示
      type: 'info', // 错误类型（success info warning error）四种，默认为warning类型
      message: (
        <span>
          设置公众号同步后，可根据设置将公众号的最新内容同步至微官网，仅认证通过的公众号可以进行同步。每天17:30从公众号同步新增的素材内容，由于无法识别素材内容是否已编辑完成，请谨慎设置自动发布功能。
          <a onClick={() => this.setState({ showSettingSteps: true })} style={{ marginLeft: 15 }}>
            查看如何设置
          </a>
        </span>
      ), // 展示的内容
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements: dataSource.length, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    return (
      <Container breStates={!0} version={2} alertParams={alertParams}>
        <ListPage {...pageProps}>
          <section className="create-button">
            <Button
              type="primary"
              onClick={() => this.setState({ modifyModalVisible: true, type: '新增', record: {} })}
            >
              新增公众号
            </Button>
          </section>
          <section className="table-area">
            {/* <Table
              columns={columns}
              dataSource={dataSource}
              loading={loading}
              footer={() => `共 ${dataSource.length} 条记录 第 1 页`}
            /> */}
            <ListTable {...tableProps} />
          </section>
          {modifyModalVisible && (
            <ModifyModal
              modifyModalVisible={modifyModalVisible}
              type={type}
              record={record}
              closeModifyModal={this.closeModifyModal}
              fetchAllConfigure={this.fetchAllConfigure}
              channelList={channelList}
            />
          )}
          <Modal
            className={styles['setting-steps']}
            width={900}
            centered
            title={
              <div>
                公众号设置流程<span>注意：公众号必须认证过，若未认证将无法同步</span>
              </div>
            }
            onCancel={this.hideSettingSteps}
            visible={showSettingSteps}
            footer={[
              <Button type="primary" onClick={this.hideSettingSteps}>
                知道了
              </Button>,
            ]}
          >
            <img
              style={{ width: '100%' }}
              src="https://s.xiaoyuanhao.com/file/b18284f6-4b97-431f-9d23-0daa6b3a8fa4.jpg"
              alt=""
            />
            <div className='content'>按照下图格式将47.98.43.105 47.99.171.62 118.31.56.8配置为白名单，确认无误后点击确认修改，并请公众号管理员或长期运营者扫码验证。</div>
            <img
              style={{ width: '100%' }}
              src="https://s.xiaoyuanhao.com/file/34c2b47c-248b-42d0-b24b-c870e68e271e.jpg"
              alt=""
            />
          </Modal>
        </ListPage>
      </Container>
    );
  }
}
export default PublicSetting;
